import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Module, ModuleState, SubmoduleFilter } from './types/modules';

const initialState: ModuleState = {
  modules: [],
  userManagementModules: [],
  loadCount: 0,
  filtersFetched: false,
};

export const ModulesData = createSlice({
  name: 'Modules',
  initialState,
  reducers: {
    setAuthorisedModule: (
      state,
      action: PayloadAction<{
        modules: Module[];
        userManagementModules: Module[];
      }>,
    ) => {
      if (action.payload.modules.length > 0) {
        state.modules = [...action.payload.modules];
      }
      if (action.payload.userManagementModules.length > 0) {
        state.userManagementModules = [...action.payload.userManagementModules];
      }
    },
    setSubModuleFilterOptions: (
      state,
      action: PayloadAction<{
        module_id: string;
        sub_module_id: string;
        filter_options: SubmoduleFilter[];
      }>,
    ) => {
      const { module_id, sub_module_id, filter_options } = action.payload;

      const module = state.userManagementModules.find((m) => m.id === module_id);
      if (module) {
        const submodule = module.submodules?.find((s) => s.id === sub_module_id);
        if (submodule) {
          submodule.filters = [...filter_options];
        }
      }
    },
    setLoadCount: (state) => {
      state.loadCount += 1;
    },
    resetLoadCount: (state) => {
      state.loadCount = 0;
    },
    setFiltersFetched: (state) => {
      state.filtersFetched = true;
    },
  },
});

export const {
  setAuthorisedModule,
  setSubModuleFilterOptions,
  setLoadCount,
  resetLoadCount,
  setFiltersFetched,
} = ModulesData.actions;

export default ModulesData.reducer;
